import { render, staticRenderFns } from "./og-custom-select.vue?vue&type=template&id=5b77e248&"
import script from "./og-custom-select.vue?vue&type=script&lang=js&"
export * from "./og-custom-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports